module.exports = __webpack_public_path__ + "img/Villa_Borna_28.93028073.jpg";